import { useNavigate } from "react-router-dom";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  LicenseTypes,
  Operation,
  PageFor,
  empType,
} from "../../../../../utils/Enum.types";
import React, { useContext, useEffect, useState } from "react";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {
  DEFAULT_TIME,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { TableHeaderProps } from "../../../../../utils/types";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import Navbar from "../../../../common/layout/Navbar";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import Modal from "react-modal";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import AddProjectDetails from "./AddProjectExtDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import MessageModal from "../../../../../customComponents/MessageModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetProjectExts } from "./queries/queries";
import {
  AtsAcLdgrProjectExtEdge,
  AtsAcLdgrProjectExtOrderField,
  DeleteProjectExtResult,
  DeleteProjectExtVar,
  GetProjectExtsResult,
  GetProjectExtsVar,
} from "./queries/types";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import {
  getModifiedScrollHeight,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { payloadTypes } from "../../../../../context/reducer";
import { DeleteProjectExt } from "./queries/mutations";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Close from "../../../../../images/Close.svg";

export interface ModalType {
  operation: Operation;
  id: number;
  flag: boolean;
}
interface Props {
  pageType: PageFor;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProjectExtDetails = ({ pageType, setModalFlag }: Props) => {
  const { ProjectExt } = useAssetTableJson();

  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const { customer_id } = useUrlParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [employees, setEmployees] = useState<AtsAcLdgrProjectExtEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const [operation, setOperation] = useState<Operation>(Operation.CREATE);
  const [searchData, setSearchData] = useState("");
  const { user_details } = useLoggedInUserDetails();

  const [getProjects, { data, loading, fetchMore }] = useLazyQuery<
    GetProjectExtsResult,
    GetProjectExtsVar
  >(GetProjectExts);

  const [deleteProject, { loading: deleteLoading }] = useMutation<
    DeleteProjectExtResult,
    DeleteProjectExtVar
  >(DeleteProjectExt, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = ProjectExt.List.filter(
    (header) => pageType === PageFor.MODAL || pageType === PageFor.GENERAL
  ).map((header) => ({
    headerName: header.headerName,
    cellClassName: header.cellClassName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    renderCell: (params) => {
      if (
        state.empSubType === empType.SYS_ADMIN ||
        state.empSubType === empType.PMU
      ) {
        if (params.field === "actions") {
          return (
            <>
              <img
                src={Edit}
                alt="/"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_PROJECT_EXT_ID,
                    payload: {
                      projectExtId: Number(params.row.projectExtId),
                    },
                  });
                  setOperation(Operation.UPDATE);
                  setAddModal(true);
                }}
              />
              <img
                src={Delete}
                alt="/"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_PROJECT_EXT_ID,
                    payload: {
                      projectExtId: Number(params.row.projectExtId),
                    },
                  });
                  setDeleteModal(!deleteModal);
                }}
              />
            </>
          );
        }
      } else return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const HandleDelete = async () => {
    try {
      if (customer_id) {
        setDeleteModal(!deleteModal);
        deleteProject({
          variables: {
            user_details,
            customerID: customer_id,
            projectExtID: state.projectExtId,
          },
          refetchQueries: [
            {
              query: GetProjectExts,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
                projectID: state.projectId,
                after: null,
                first: ROWS_PER_PAGE,
                name: searchData,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrProjectExtOrderField.CREATED_AT,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteProjectExt) {
            setMessage({
              flag: true,
              message: "Delete Project successfully",
              operation: Operation.DELETE,
            });
            dispatch({
              type: payloadTypes.SET_PROJECT_EXT_ID,
              payload: {
                projectExtId: 0,
              },
            });
          }
        });
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetProjectExts.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = employees.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setEmployees(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            projectExtId: node.id,
            name: node.name,
            vendor: node.supplierName.desc,
            startDate:
              node.startDate &&
              toStandardDate(node.startDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.startDate)
                : "-",

            endDate:
              node.endDate &&
              toStandardDate(node.endDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.endDate)
                : "-",
          }))
        );
      } else {
        setEmployees(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            projectExtId: node.id,
            name: node.name,
            vendor: node.supplierName.desc,
            startDate:
              node.startDate &&
              toStandardDate(node.startDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.startDate)
                : "-",
            endDate:
              node.endDate &&
              toStandardDate(node.endDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.endDate)
                : "-",
          }))
        );
      }
      setEndCursor(data.GetProjectExts.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetProjectExts.edges;
              const pageInfo = fetchMoreResult.GetProjectExts.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetProjectExts.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetProjectExts: {
                  edges: [...employees, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetProjectExts.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id && state.projectId) {
          getProjects({
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              after: null,
              first: ROWS_PER_PAGE,
              name: searchData,
              projectID: state.projectId,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrProjectExtOrderField.CREATED_AT,
              },
            },
          });
        }
      } catch (err) {
        setMessage({
          flag: true,
          message: (err as Error).message,
          operation: Operation.NONE,
        });
      }
    };
    fetchData();
  }, [customer_id, getProjects, user_details.id, searchData, state.projectId]);

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      setAddModal(true);
      setOperation(Operation.CREATE);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.PROJECTS_LIST);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.PROJECTS_LIST,
      JSON.stringify(newModel)
    );
  };

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar
          NavType={
            state.empSubType === empType.PMU ||
            state.empSubType === empType.VENDOR_MANAGER
              ? LicenseTypes.DASHBOARD
              : LicenseTypes.CUSTOMER_USERS
          }
        />
      )}

      <div className="projects-list__title">
        <Title>Project Extension Details</Title>
        {pageType === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <div
        className={`projects-list${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        <div className="row g-0 projects-list__filters">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search ..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchData(e.target.value)
              }
            />
          </div>

          {(state.empSubType === empType.SYS_ADMIN ||
            state.empSubType === empType.PMU) && (
            <div className="col flex-end">
              <Button
                mode="addnew"
                autoFocus
                onClick={() => {
                  setAddModal(true);
                  setOperation(Operation.CREATE);
                }}
              />
            </div>
          )}
        </div>
        <div className="projects-list__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
            onCellClick={(params) => {
              if (params.field === "name") {
                dispatch({
                  type: payloadTypes.SET_PROJECT_EXT_ID,
                  payload: {
                    projectExtId: params.row.projectExtId,
                  },
                });
                setOperation(Operation.VIEW);
                setAddModal(true);
              }
            }}
          />
        </div>
        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate(-1)} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <Modal isOpen={addModal} style={AddModalStyles} ariaHideApp={false}>
        <AddProjectDetails setModalFlag={setAddModal} operation={operation} />
      </Modal>

      <LoadingModal flag={!searchData && loading} />
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default ProjectExtDetails;
